import { ApplicationNames } from './shared';
import envConfig from '../config/config';

const THERAPIES_SITES_ROLES = ['sundial-role:T_SITE_BASE_USER'];

export const therapiesSitesApplication = {
  name: ApplicationNames.THERAPIES_SITES,
  url: envConfig.apps.therapiesSites,
  roles: THERAPIES_SITES_ROLES,
};
